/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Iframe from 'DesignSystem/Iframe/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/PerformTrace/Content/Content/CalibrationTool/Content"
  
}) {
let selectedCalibrationUrlValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'calibration_url',
})
  return (<React.Fragment
>
<Iframe
  viewPath={`${viewPath}/Iframe`}
 data="selected.calibration_url"
 src={selectedCalibrationUrlValueData}
/>
{children}
</React.Fragment>)
}